import { DefaultError, useMutation } from "@tanstack/react-query";
import { updatePage } from "../api/updatePage";
import { invalidatePagesListByBrandsQuery } from "../queries/usePagesListByBrandQuery";
import { Page } from "../types";

type Params = {
  pageData: Partial<Page>;
  brandId: string;
  pageId: string;
};

export const useUpdatePageMutation = (onSuccess: () => void) => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      await updatePage(params);
    },
    onSuccess: (_, { brandId }) => {
      invalidatePagesListByBrandsQuery(brandId);
      onSuccess && onSuccess();
    },
    onError: (e) => {
      console.error("Error occurred when creating module", e);
    },
  });
};
